module.exports = __webpack_public_path__ + "static/media/img87.426d79a6.jpg";